import { useNavigate } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import { useUserStore } from '@/stores/userStore'
import { supabase } from '@/lib/supabase'

export function useSignOut() {
  const reset = useAuthStore((state) => state.auth.reset)
  const { resetUser } = useUserStore((state) => state.user)
  const navigate = useNavigate()

  async function signOut() {
    const { error } = await supabase.auth.signOut()
    if (error) {
      console.error('Erro ao deslogar:', error.message)
    }
    resetUser()
    reset()
    navigate({ to: '/home', replace: true })
  }

  return { signOut }
}
